module.exports = __webpack_public_path__ + "static/img/exch.dcd8fec3.png";